(function () {
  'use strict';

  var SELECTOR = '[data-fabric-selector]';
  var INITIALIZED_ATTR = 'data-fabric-initialized';

  var FabricSelectorRegistry = {
    instances: new WeakMap(),
    initAll: function (scope) {
      var root = scope || document;
      if (!root || typeof root.querySelectorAll !== 'function') return;
      var wrappers = root.querySelectorAll(SELECTOR);
      wrappers.forEach(function (wrapper) {
        FabricSelectorRegistry.init(wrapper);
      });
    },
    init: function (wrapper) {
      if (!wrapper || wrapper.getAttribute(INITIALIZED_ATTR) === 'true') return;
      var instance = new FabricSelector(wrapper);
      if (instance.initialized) {
        wrapper.setAttribute(INITIALIZED_ATTR, 'true');
        FabricSelectorRegistry.instances.set(wrapper, instance);
      }
    }
  };

  function parseKeywordsAttr(keywordsAttr, legacyKeyword) {
    var keywords = [];
    if (keywordsAttr) {
      keywords = keywordsAttr.split(',').map(function (keyword) {
        return keyword.toLowerCase().trim();
      });
    }
    keywords = keywords.filter(function (keyword, index, self) {
      return keyword.length > 0 && self.indexOf(keyword) === index;
    });
    legacyKeyword = (legacyKeyword || '').toLowerCase().trim();
    if (!keywords.length && legacyKeyword) {
      keywords = [legacyKeyword];
    }
    return keywords;
  }

  function buildKeywordsFromValue(rawValue) {
    var base = (rawValue || '').toString().trim().toLowerCase();
    if (!base) return [];
    var keywords = [base];
    var hyphenated = base.replace(/\s+/g, '-');
    var condensed = base.replace(/\s+/g, '');
    [hyphenated, condensed].forEach(function (keyword) {
      if (keyword && keywords.indexOf(keyword) === -1) {
        keywords.push(keyword);
      }
    });
    return keywords;
  }

  function FabricSelector(wrapper) {
    this.wrapper = wrapper;
    this.wrapperId = wrapper.id || '';
    this.requireSelection = wrapper.hasAttribute('data-require-selection');
    this.errorTarget = wrapper.querySelector('[data-fabric-error]');
    this.toggle = wrapper.querySelector('[data-fabric-select-toggle]');
    this.optionPanel = wrapper.querySelector('[data-fabric-option-panel]');
    this.optionList = wrapper.querySelector('[data-fabric-option-list]');
    this.valueInput = wrapper.querySelector('[data-fabric-input]');
    this.skuInput = wrapper.querySelector('[data-fabric-sku-input]');
    this.labelTarget = wrapper.querySelector('[data-fabric-selected-label]');
    this.thumbTarget = wrapper.querySelector('[data-fabric-selected-thumbnail]');
    this.placeholder = wrapper.getAttribute('data-placeholder') || '';
    this.debugDefault = (wrapper.getAttribute('data-fabric-debug-default') || '').toLowerCase();
    this.debugEnabled = this.debugDefault === 'true' || this.debugDefault === '1';
    this.fabricOptionPosition = parseInt(wrapper.getAttribute('data-fabric-option-position') || '-1', 10);
    this.productInfoEl = wrapper.closest('product-info');
    this.parentSectionId = this.productInfoEl ? this.productInfoEl.dataset.section : null;
    this.options = Array.prototype.slice.call(wrapper.querySelectorAll('[data-fabric-option]'));
    this.optionItems = this.options.map(function (optionEl) {
      return optionEl.closest('li') || optionEl;
    });
    this.activeKeywords = [];
    this.initialized = false;
    this.boundDocumentClick = this.handleDocumentClick.bind(this);
    this.boundWrapperKeyup = this.handleWrapperKeyup.bind(this);
    this.boundVariantEvent = this.handleVariantEvent.bind(this);
    this.boundFabricSelectionSync = this.handleFabricSelectionSync.bind(this);

    if (!this.toggle || !this.optionPanel || !this.optionList || !this.valueInput || !this.skuInput || !this.labelTarget || !this.thumbTarget) {
      return;
    }

    this.init();
  }

  FabricSelector.prototype.updateDebugFromRuntime = function () {
    var enabled = this.debugEnabled;
    try {
      var fabricDebugParam = new URLSearchParams(window.location.search).get('fabricDebug');
      if (fabricDebugParam === '1' || (fabricDebugParam || '').toLowerCase() === 'true') {
        enabled = true;
      }
    } catch (error) {
      // ignore URL parsing errors
    }
    if (window.FabricSelectorDebug === true) {
      enabled = true;
    }
    this.debugEnabled = enabled;
  };

  FabricSelector.prototype.log = function () {
    if (!this.debugEnabled || typeof console === 'undefined') return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[Fabric selector]', this.wrapperId || this.wrapper);
    console.log.apply(console, args);
  };

  FabricSelector.prototype.warn = function () {
    if (!this.debugEnabled || typeof console === 'undefined') return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[Fabric selector]', this.wrapperId || this.wrapper);
    console.warn.apply(console, args);
  };

  FabricSelector.prototype.setErrorState = function (show) {
    if (!this.errorTarget) return;
    this.errorTarget.hidden = !show;
    this.wrapper.toggleAttribute('data-fabric-error', show);
  };

  FabricSelector.prototype.init = function () {
    this.updateDebugFromRuntime();
    var initialKeywords = parseKeywordsAttr(
      this.wrapper.getAttribute('data-fabric-filter-keywords') || '',
      this.wrapper.getAttribute('data-fabric-filter-keyword') || ''
    );
    this.activeKeywords = initialKeywords.slice();

    if (this.debugEnabled) {
      console.groupCollapsed('[Fabric selector debug]', this.wrapperId || this.wrapper);
      console.log('filter present:', this.wrapper.getAttribute('data-fabric-filter-present') === 'true');
      console.log('filter raw:', this.wrapper.getAttribute('data-fabric-filter-raw') || '');
      console.log('filter keywords initial:', this.activeKeywords);
      console.log('options total:', this.options.length);
      console.groupEnd();
    }

    var visibleCount = this.setFilterKeywords(
      initialKeywords,
      this.wrapper.getAttribute('data-fabric-filter-raw') || ''
    );
    if (this.activeKeywords.length && visibleCount === 0) {
      this.warn('hidden due to filter (no matches).');
      return;
    }

    this.bindEvents();
    this.initialized = true;
    document.dispatchEvent(
      new CustomEvent('fabric:selector-ready', {
        detail: {
          wrapperId: this.wrapperId,
          requireSelection: this.requireSelection
        }
      })
    );
    this.log('initialized', {
      fabricOptionPosition: this.fabricOptionPosition,
      initialKeywords: this.activeKeywords
    });
  };

  FabricSelector.prototype.bindEvents = function () {
    var _this = this;
    this.toggle.addEventListener('click', function () {
      if (_this.optionPanel.hidden) {
        _this.openList();
      } else {
        _this.closeList();
      }
    });

    this.options.forEach(function (optionEl) {
      optionEl.addEventListener('click', function () {
        _this.updateSelection(optionEl);
        _this.closeList();
      });
    });

    document.addEventListener('click', this.boundDocumentClick);
    this.wrapper.addEventListener('keyup', this.boundWrapperKeyup);

    if (this.requireSelection) {
      var formEl = this.wrapper.closest('form');
      if (formEl) {
        formEl.addEventListener('submit', function (event) {
          if (!_this.valueInput.value) {
            event.preventDefault();
            _this.setErrorState(true);
            _this.toggle.focus();
          }
        });
      }
    }

    document.addEventListener('variant:changed', this.boundVariantEvent);
    if (window.FoxTheme && FoxTheme.pubsub && typeof FoxTheme.pubsub.subscribe === 'function') {
      try {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function (payload) {
          var data = payload && payload.data;
          if (data && data.sectionId && _this.parentSectionId && data.sectionId !== _this.parentSectionId) {
            _this.log('ignoring pubsub variant event for other section', {
              eventSectionId: data.sectionId,
              parentSectionId: _this.parentSectionId
            });
            return;
          }
          _this.log('pubsub variant event received', {
            sectionId: _this.parentSectionId,
            variantId: data && data.variant ? data.variant.id : null
          });
          _this.handleVariantChange(data ? data.variant : null);
        });
      } catch (error) {
        this.warn('unable to subscribe to FoxTheme pubsub', error);
      }
    }

    document.addEventListener('fabric:selection', this.boundFabricSelectionSync);
  };

  FabricSelector.prototype.handleDocumentClick = function (event) {
    if (!this.wrapper.contains(event.target)) {
      this.closeList();
    }
  };

  FabricSelector.prototype.handleWrapperKeyup = function (event) {
    if (event.key === 'Escape') {
      this.closeList();
      this.toggle.focus();
    }
  };

  FabricSelector.prototype.handleVariantEvent = function (event) {
    this.handleVariantChange(event && event.detail ? event.detail.variant : null);
  };

  FabricSelector.prototype.handleVariantChange = function (incomingVariant) {
    var variant = this.resolveVariantForEvent(incomingVariant);
    if (!variant) return;
    this.log('variant change received', {
      sourceVariantId: incomingVariant ? incomingVariant.id : null,
      resolvedVariantId: variant.id,
      fabricOptionPosition: this.fabricOptionPosition,
      fabricValue: this.getFabricValueFromVariant(variant)
    });
    this.syncFilterWithVariant(variant);
  };

  FabricSelector.prototype.handleFabricSelectionSync = function (event) {
    if (!event.detail || !event.detail.wrapperId || event.detail.wrapperId === this.wrapperId) return;
    if (!this.requireSelection) return;
    if (this.valueInput.value === event.detail.label) return;
    this.valueInput.value = event.detail.label || '';
    if (this.labelTarget) {
      this.labelTarget.textContent = event.detail.label || this.placeholder;
    }
    this.skuInput.value = event.detail.sku || '';
    if (event.detail.sku) {
      this.skuInput.removeAttribute('disabled');
    } else {
      this.skuInput.setAttribute('disabled', 'disabled');
    }
    if (event.detail.thumbnail) {
      this.thumbTarget.innerHTML =
        '<img src="' +
        event.detail.thumbnail +
        '" alt="' +
        (event.detail.label || this.placeholder).replace(/"/g, '&quot;') +
        '" width="48" height="48" class="blocks-radius-xs object-cover">';
    } else {
      this.thumbTarget.innerHTML = '';
    }
  };

  FabricSelector.prototype.openList = function () {
    this.optionPanel.hidden = false;
    this.toggle.setAttribute('aria-expanded', 'true');
  };

  FabricSelector.prototype.closeList = function () {
    this.optionPanel.hidden = true;
    this.toggle.setAttribute('aria-expanded', 'false');
  };

  FabricSelector.prototype.updateSelection = function (optionEl) {
    var label = optionEl.getAttribute('data-option-label') || '';
    var skuValue = optionEl.getAttribute('data-option-sku') || '';
    var thumbnail = optionEl.getAttribute('data-option-thumbnail') || '';
    this.valueInput.value = label;
    if (this.labelTarget) this.labelTarget.textContent = label || this.placeholder;
    if (thumbnail) {
      this.thumbTarget.innerHTML =
        '<img src="' +
        thumbnail +
        '" alt="' +
        label.replace(/"/g, '&quot;') +
        '" width="48" height="48" class="blocks-radius-xs object-cover">';
    } else {
      this.thumbTarget.innerHTML = '';
    }
    this.skuInput.value = skuValue;
    if (skuValue) {
      this.skuInput.removeAttribute('disabled');
    } else {
      this.skuInput.setAttribute('disabled', 'disabled');
    }
    var selectionDetails = {
      label: label,
      sku: skuValue,
      thumbnail: thumbnail
    };
    this.options.forEach(function (btn) {
      btn.setAttribute('aria-selected', btn === optionEl ? 'true' : 'false');
    });
    if (this.requireSelection) {
      this.setErrorState(!this.valueInput.value);
    }
    document.dispatchEvent(
      new CustomEvent('fabric:selection', {
        detail: {
          wrapperId: this.wrapperId,
          label: selectionDetails.label || '',
          sku: selectionDetails.sku || '',
          thumbnail: selectionDetails.thumbnail || ''
        }
      })
    );
  };

  FabricSelector.prototype.matchesKeyword = function (optionEl, keywords) {
    if (!keywords.length) return true;
    var optionHandle = (optionEl.getAttribute('data-option-handle') || '').toLowerCase();
    var optionFilterText = (optionEl.getAttribute('data-option-filter-text') || '').toLowerCase();
    var optionSku = (optionEl.getAttribute('data-option-sku') || '').toLowerCase();
    return keywords.some(function (keyword) {
      return (
        (optionHandle && optionHandle.indexOf(keyword) !== -1) ||
        (optionFilterText && optionFilterText.indexOf(keyword) !== -1) ||
        (optionSku && optionSku.indexOf(keyword) !== -1)
      );
    });
  };

  FabricSelector.prototype.clearSelection = function () {
    this.valueInput.value = '';
    if (this.labelTarget) this.labelTarget.textContent = this.placeholder;
    if (this.thumbTarget) this.thumbTarget.innerHTML = '';
    this.skuInput.value = '';
    this.skuInput.setAttribute('disabled', 'disabled');
    this.options.forEach(function (btn) {
      btn.setAttribute('aria-selected', 'false');
    });
    if (this.requireSelection) {
      this.setErrorState(true);
    }
  };

  FabricSelector.prototype.applyFilterKeywords = function (keywords) {
    var _this = this;
    var hasKeywords = Array.isArray(keywords) && keywords.length > 0;
    var visibleCount = 0;
    var selectedLabel = this.valueInput.value;
    var selectionStillVisible = !selectedLabel;
    this.options.forEach(function (optionEl, index) {
      var passesFilter = _this.matchesKeyword(optionEl, keywords);
      var shouldHide = hasKeywords && !passesFilter;
      var optionItem = _this.optionItems[index];
      if (optionItem) {
        optionItem.hidden = shouldHide;
        optionItem.classList.toggle('hidden', shouldHide);
      } else {
        optionEl.hidden = shouldHide;
      }
      optionEl.tabIndex = shouldHide ? -1 : 0;
      optionEl.toggleAttribute('data-filter-hidden', shouldHide);
      if (!shouldHide) {
        visibleCount += 1;
        if (selectedLabel && !selectionStillVisible) {
          if ((optionEl.getAttribute('data-option-label') || '') === selectedLabel) {
            selectionStillVisible = true;
          }
        }
      }
    });
    if (selectedLabel && !selectionStillVisible) {
      this.clearSelection();
    }
    if (hasKeywords && visibleCount === 0) {
      this.wrapper.setAttribute('hidden', 'hidden');
      this.valueInput.removeAttribute('required');
    } else {
      this.wrapper.removeAttribute('hidden');
      if (this.requireSelection) {
        this.valueInput.setAttribute('required', 'required');
      }
    }
    if (this.requireSelection) {
      this.setErrorState(!this.valueInput.value);
    }
    return visibleCount;
  };

  FabricSelector.prototype.updateFilterAttributes = function (fabricValue, keywords) {
    var rawValue = fabricValue || '';
    var keywordList = Array.isArray(keywords) ? keywords : [];
    this.wrapper.setAttribute('data-fabric-filter-raw', rawValue);
    this.wrapper.setAttribute('data-fabric-filter-value', rawValue.toUpperCase());
    this.wrapper.setAttribute('data-fabric-filter-keywords', keywordList.join(','));
    this.wrapper.setAttribute('data-fabric-filter-keyword', keywordList[0] || '');
    this.wrapper.setAttribute('data-fabric-filter-present', keywordList.length ? 'true' : 'false');
  };

  FabricSelector.prototype.setFilterKeywords = function (keywords, fabricValue) {
    if (!Array.isArray(keywords)) {
      keywords = [];
    }
    this.activeKeywords = keywords.slice();
    var visibleCount = this.applyFilterKeywords(this.activeKeywords);
    this.updateFilterAttributes(fabricValue, this.activeKeywords);
    this.log('keywords applied', {
      fabricValue: fabricValue,
      keywords: this.activeKeywords,
      visibleCount: visibleCount
    });
    return visibleCount;
  };

  FabricSelector.prototype.getVariantFromProductInfo = function () {
    if (!this.productInfoEl) return null;
    var scriptEl = this.productInfoEl.querySelector('variant-selects [data-selected-variant]');
    if (!scriptEl) return null;
    var scriptContent = scriptEl.textContent || scriptEl.innerHTML || '';
    if (!scriptContent.trim()) return null;
    try {
      return JSON.parse(scriptContent);
    } catch (error) {
      this.warn('failed to parse current variant JSON', error);
      return null;
    }
  };

  FabricSelector.prototype.getFabricValueFromVariant = function (variant) {
    if (!variant || this.fabricOptionPosition < 0) {
      return '';
    }
    if (Array.isArray(variant.options) && variant.options.length > this.fabricOptionPosition) {
      return variant.options[this.fabricOptionPosition] || '';
    }
    var optionProperty = 'option' + (this.fabricOptionPosition + 1);
    return variant[optionProperty] || '';
  };

  FabricSelector.prototype.syncFilterWithVariant = function (variant) {
    if (this.fabricOptionPosition < 0) {
      return;
    }
    var fabricValue = this.getFabricValueFromVariant(variant);
    var keywords = buildKeywordsFromValue(fabricValue);
    var currentRaw = this.wrapper.getAttribute('data-fabric-filter-raw') || '';
    if ((fabricValue || '') === currentRaw && keywords.join(',') === this.activeKeywords.join(',')) {
      this.log('variant fabric unchanged; skipping update', { fabricValue: fabricValue });
      return;
    }
    this.setFilterKeywords(keywords, fabricValue);
  };

  FabricSelector.prototype.resolveVariantForEvent = function (incomingVariant) {
    if (incomingVariant && Array.isArray(incomingVariant.options) && incomingVariant.options.length) {
      return incomingVariant;
    }
    return this.getVariantFromProductInfo();
  };

  // Initialize on ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      FabricSelectorRegistry.initAll();
    });
  } else {
    FabricSelectorRegistry.initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    FabricSelectorRegistry.initAll(event.target);
  });
  document.addEventListener('shopify:section:reorder', function (event) {
    FabricSelectorRegistry.initAll(event.target);
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(SELECTOR)) {
          FabricSelectorRegistry.init(node);
        } else if (typeof node.querySelectorAll === 'function') {
          FabricSelectorRegistry.initAll(node);
        }
      });
    });
  });
  observer.observe(document.documentElement || document.body, {
    childList: true,
    subtree: true
  });

  window.FabricSelectorRegistry = FabricSelectorRegistry;
})();


